module.exports = __webpack_public_path__ + "_/CommonFrontend/AcceptFlow/BasicForm/Images/User.svg";